import indemnisation from '@amo/core/assets/images/icons/indemnisation.png';
import { BulleAide, Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import { Field } from 'redux-form';
import {getTranslation} from "../../../utils/index.js";

export const IndemAccidentResponsable = (props) => {
    const { nextQuestion, data } = props;

    return (
        <Question asFieldset required
            icon={indemnisation}
            title={getTranslation('yourNeedes.faultAccident.title')}
            subtitle={getTranslation('yourNeedes.faultAccident.subtitle')}
            position={'bottom'}
        >
            <div className={'row justify-content-center'}>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[DevoirConseil][DevoirIC]'}
                        value={'1'}
                        label={getTranslation('yes')}
                    />
                </div>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[DevoirConseil][DevoirIC]'}
                        value={'0'}
                        label={getTranslation('no')}
                    />
                </div>
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${
                    !_.get(data, 'DemandeTarif[DevoirConseil][DevoirIC]') && 'disabled'
                }`}
                onClick={() => nextQuestion()}
            >
                {getTranslation('continue')}
            </button>

            <BulleAide
                title={getTranslation('yourNeedes.faultAccident.help.title')}
                text={getTranslation('yourNeedes.faultAccident.help.text')}
            />
        </Question>
    );
};
